import { chain as placeOrderChain } from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/PlaceOrder";
import { PopulateAddLineCollectionApiParameter as oldPopulateAddLineCollectionApiParameter } from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/PlaceOrder";
import { replaceInChain } from "@preferredMedical/HandlerCreator";
import { PopulateAddLineCollectionApiParameter as newPopulateAddLineCollectionApiParameter } from "@preferredMedical/NdcHandlersChanged/CommonHandlers/PopulateAddLineCollectionApiParameter";

const NdcReplacePopulateAddLineCollectionApiParameterHandler = () => {
    replaceInChain(
        placeOrderChain,
        oldPopulateAddLineCollectionApiParameter,
        newPopulateAddLineCollectionApiParameter,
    );
};

export default NdcReplacePopulateAddLineCollectionApiParameterHandler;